import { Modal, Platform, Pressable, Text, View } from "react-native";
import { BlurView } from "expo-blur";
import { FlaskConical, X } from "lucide-react-native";
import { useTranslations } from "@src/packages/i18n";
import { EMBER } from "../../onboarding/theme";
import { EVIDENCE_LEVELS } from "./EvidenceLevelChip";
import { usePressCapture } from "@src/packages/analytics/usePressCapture";

export default function EvidenceLevelModal({
  level,
  visible,
  onClose,
}: {
  level: string | null;
  visible: boolean;
  onClose: () => void;
}) {
  const t = useTranslations();
  const capturePress = usePressCapture("EvidenceLevelModal");
  if (!level) return null;
  const info = EVIDENCE_LEVELS[level];
  if (!info) return null;

  const content = (
    <>
      <Pressable
        onPress={() => {
          capturePress("close_evidence_level");
          onClose();
        }}
        hitSlop={12}
        style={{
          position: "absolute",
          top: 12,
          right: 12,
          width: 28,
          height: 28,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <X size={14} color={EMBER.colors.textFaint} />
      </Pressable>

      <FlaskConical size={28} color={EMBER.colors.textMid} strokeWidth={1.5} />

      <Text
        className="font-dm-sans"
        style={{
          fontSize: 18,
          fontWeight: "700",
          color: EMBER.colors.text,
          marginTop: 14,
          textAlign: "center",
        }}
      >
        {t(`learn.evidence_levels.${info.i18nKey}.label`)}
      </Text>

      <Text
        className="font-dm-sans"
        style={{
          fontSize: 14,
          color: EMBER.colors.textMid,
          lineHeight: 21,
          marginTop: 10,
          textAlign: "center",
        }}
      >
        {t(`learn.evidence_levels.${info.i18nKey}.description`)}
      </Text>
    </>
  );

  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onClose}
    >
      <Pressable
        onPress={() => {
          capturePress("dismiss_evidence_level_backdrop");
          onClose();
        }}
        style={{
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(0,0,0,0.4)",
        }}
      >
        <Pressable
          onPress={(event) => event.stopPropagation()}
          style={{
            width: "85%",
            maxWidth: 340,
            borderRadius: 20,
            overflow: "hidden",
          }}
        >
          {Platform.OS === "web" ? (
            <View
              style={
                {
                  paddingHorizontal: 28,
                  paddingTop: 36,
                  paddingBottom: 28,
                  alignItems: "center",
                  backgroundColor: "rgba(255,255,255,0.82)",
                  backdropFilter: "blur(24px) saturate(1.4)",
                  WebkitBackdropFilter: "blur(24px) saturate(1.4)",
                } as Record<string, unknown>
              }
            >
              {content}
            </View>
          ) : (
            <BlurView
              intensity={80}
              tint="light"
              style={{
                paddingHorizontal: 28,
                paddingTop: 36,
                paddingBottom: 28,
                alignItems: "center",
              }}
            >
              {content}
            </BlurView>
          )}
        </Pressable>
      </Pressable>
    </Modal>
  );
}
